import "./ProgressCircle.css";

type Props = {
  value: number;
};

/* eslint-disable @typescript-eslint/no-unused-vars */
export function ProgressCircle(_: Props) {
  return (
    <div className="progress-circle">
      <div></div>
    </div>
  );
}
